import type { ColDef } from "ag-grid-community";
import {
  idColumn,
  nameColumn,
  codeColumn,
  actionColumn,
  statusColumn,
} from "../../../../../utils/commonColumns";
import { generateColumn, textFormatEditor } from "../../../../../utils/commonFunctions";

const columnDefs: ColDef[] = [
  idColumn,
  nameColumn,
  codeColumn,
  {
    ...generateColumn("", "industry_name"),
    ...textFormatEditor("industry_name"),
  },
  statusColumn,
  actionColumn,
];
export default columnDefs;
